(function($) {
	"use strict";
	
	function init() {
		$('.js-submit-job-posting-btn').click(submitJobPosting);
		$('.delete-job-posting-file-btn').click(deleteJobFile);
		$('.job-title-input').keyup(updateBindedText);
	}

	function submitJobPosting() {
		let form = $(this).closest('form');
		let dateEnd = form.find('input[name=dateEnd]').val();
		form.append('<input type="hidden" name="dateEndYear" value="'+dateEnd.split('-')[2]+'"/>');
		form.append('<input type="hidden" name="dateEndMonth" value="'+(dateEnd.split('-')[1] - 1)+'"/>');
		form.append('<input type="hidden" name="dateEndDay" value="'+dateEnd.split('-')[0]+'"/>');

		form.submit();
	}
    
    function deleteJobFile() {
        var btn = $(this);

        btn.closest('.element-to-delete').fadeOut(function() {
            $(this).remove();
        });
        btn.closest('form').append('<input type="hidden" name="' + btn.attr('data-name') + '" value="true"/>');
    };
    
    function updateBindedText() {
        var input = $(this);

    	$('.js-edit-job-name').html(input.val());
    };
	
	$(init);
	
})(jQuery);